var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3635 0.6C11.3667 0.566829 11.375 0.523902 11.375 0.487805C11.375 0.218537 11.1697 0 10.9167 0C10.809 0 10.7333 0.0429268 10.704 0.0551219C9.14796 0.701951 3.125 7.08098 3.125 12.6829C3.125 16.7239 6.20317 20 10 20C14.175 20 16.875 16.2571 16.875 12.6829C16.875 6.73805 10.292 5.64049 11.3635 0.6Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.18338,
    y1: 5.13171,
    x2: 15.3248,
    y2: 16.7279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2734"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4951E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotWater);
export default __webpack_public_path__ + "static/media/hot-water.b14b41ffdd3a698a1ad1bda2b7ee62f3.svg";
export { ForwardRef as ReactComponent };